module.exports = __webpack_public_path__ + "assets/8edc0e7a6b8da93723f9b40af41ae12f.gif";